import { TextCell } from "@similarweb/pro-logic-components";
import { colorsPalettes } from "@similarweb/styles";

import { NO_DATA_SIGN } from "app/filters/const";

export const NoDataCell = () => <TextCell color={colorsPalettes.carbon[250]}>{NO_DATA_SIGN}</TextCell>;
